<template>
  <div class="box">
    <div class="success">
      <div
        class="sucimg"
        v-lazy:background-image="require('../../assets/images/success.png')"
      ></div>
      <div class="sucfont">
        稍后我们的课程顾问老师将与您联系安排试读课程<br />
        体验哈兔好课程，好老师，好效果，请保持电话畅通<br />
        及时查看微信好友信息与邮件信息<br />
      </div>
      <div
        class="return"
        @click="handelBack"
        v-lazy:background-image="require('../../assets/images/probtn.png')"
      >
        返回上一页
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handelBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.success {
  // min-height: calc(100vh - 348px);
  padding: 120px 0px 30px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff7f00;
  .sucimg {
    width: 346px;
    height: 214px;
    // background-image: url("../../assets/images/success.png");
    background-repeat: no-repeat;
    background-size: 100%;
    margin: 0 auto;
  }
  .sucfont {
    line-height: 25px;
    text-align: center;
  }
  .return {
    width: 215px;
    height: 79px;
    // background-image: url("../../assets/images/probtn.png");
    background-repeat: no-repeat;
    background-size: 100%;
    margin: 0 auto;
    font-size: 15px;
    font-weight: bold;
    color: #ffffff;
    line-height: 79px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/success/index.vue